// extracted by mini-css-extract-plugin
module.exports = {"icon":"PageNotFound_icon__2ixFZ","message":"PageNotFound_message__OYMHO","container":"PageNotFound_container__3crdr","title":"PageNotFound_title__QLbYK"};